import {
  FeatureToggleIdentifier,
  isFeatureEnabled,
} from "@/services/feature-toggle-adapter";

/** Maintenance follows the build-time feature flag and needs no network subscription. */
export default function useMaintenanceConfig() {
  return {
    isMaintenanceMode: isFeatureEnabled(
      FeatureToggleIdentifier.ENABLE_MAINTENANCE_MODE
    ),
  };
}
